const signing_keys = {
    title: 'คีย์ลงนาม',
    description: 'จัดการคีย์ลงนามที่แอปพลิเคชันของคุณใช้ได้อย่างปลอดภัย',
    private_key: 'คีย์ OIDC ส่วนตัว',
    private_keys_description: 'คีย์ OIDC ส่วนตัวใช้สำหรับลงนามในโทเค็น JWT',
    cookie_key: 'คีย์ OIDC คุกกี้',
    cookie_keys_description: 'คีย์ OIDC คุกกี้ใช้สำหรับลงนามในคุกกี้',
    private_keys_in_use: 'คีย์ส่วนตัวที่กำลังใช้งาน',
    cookie_keys_in_use: 'คีย์คุกกี้ที่กำลังใช้งาน',
    rotate_private_keys: 'หมุนเวียนคีย์ส่วนตัว',
    rotate_cookie_keys: 'หมุนเวียนคีย์คุกกี้',
    rotate_private_keys_description: 'การดำเนินการนี้จะสร้างคีย์ลงนามส่วนตัวใหม่ หมุนเวียนคีย์ปัจจุบัน และลบคีย์ก่อนหน้า โทเค็น JWT ที่ลงนามด้วยคีย์ปัจจุบันจะยังใช้งานได้จนกว่าจะถูกลบหรือหมุนเวียนรอบใหม่',
    rotate_cookie_keys_description: 'การดำเนินการนี้จะสร้างคีย์คุกกี้ใหม่ หมุนเวียนคีย์ปัจจุบัน และลบคีย์ก่อนหน้า คุกกี้ที่ใช้กับคีย์ปัจจุบันจะยังใช้งานได้จนกว่าจะถูกลบหรือหมุนเวียนรอบใหม่',
    select_private_key_algorithm: 'เลือกอัลกอริทึมของคีย์ลงนามสำหรับคีย์ส่วนตัวใหม่',
    rotate_button: 'หมุนเวียน',
    table_column: {
        id: 'ID',
        status: 'สถานะ',
        algorithm: 'อัลกอริทึมของคีย์ลงนาม',
        effective_at: 'มีผลเมื่อ',
    },
    status: {
        next: 'ถัดไป',
        current: 'ปัจจุบัน',
        previous: 'ก่อนหน้า',
        effective_in: 'มีผลใน {{time}}',
    },
    reminder: {
        rotate_private_key: 'คุณแน่ใจหรือว่าต้องการหมุนเวียน <strong>คีย์ OIDC ส่วนตัว</strong>? โทเค็น JWT ที่ออกใหม่จะถูกลงนามด้วยคีย์ใหม่ โทเค็น JWT เดิมจะยังคงใช้งานได้จนกว่าคุณจะหมุนเวียนอีกครั้ง',
        rotate_cookie_key: 'คุณแน่ใจหรือว่าต้องการหมุนเวียน <strong>คีย์ OIDC คุกกี้</strong>? คุกกี้ที่สร้างใหม่ระหว่างการเข้าสู่ระบบจะถูกลงนามด้วยคีย์คุกกี้ใหม่ คุกกี้เดิมจะยังคงใช้งานได้จนกว่าคุณจะหมุนเวียนอีกครั้ง',
        delete_private_key: 'คุณแน่ใจหรือว่าต้องการลบ <strong>คีย์ OIDC ส่วนตัว</strong>? โทเค็น JWT เดิมที่ลงนามด้วยคีย์ส่วนตัวนี้จะไม่สามารถใช้งานได้อีก',
        delete_cookie_key: 'คุณแน่ใจหรือว่าต้องการลบ <strong>คีย์ OIDC คุกกี้</strong>? เซสชันเข้าสู่ระบบเดิมที่ใช้คุกกี้ลงนามด้วยคีย์นี้จะไม่สามารถใช้งานได้อีก ผู้ใช้ต้องล็อกอินใหม่',
    },
    messages: {
        rotate_key_success: 'หมุนเวียนคีย์ลงนามสำเร็จแล้ว',
        delete_key_success: 'ลบคีย์สำเร็จแล้ว',
    },
};
export default Object.freeze(signing_keys);
